const INITIAL_STATE = {
    tours: {
      data: []
    },
    tour: null,
    tourFetched: []
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'TOUR_FETCH':
        return { ...state, tours: action.payload }
      case 'TOUR_SET':
        return { ...state, tour: action.payload }
      case 'TOURS_FETCH':
        return { ...state, tourFetched: action.payload }
      default:
        return state
    }
  }